import classNames from "classnames";
import { DComponent } from "../DComponent";
import { Sticky } from '../../utils/sticky';
import { LocalStorage } from "../../models/LocalStorage";
import { getParamUrl } from "../../utils/url";
import { ROOT_GLOBAL } from "../../global/root";
import { getExtensionLink } from "../../utils/browser";
import { detectLanguage, setupLanguage } from "../../utils/language";
import CollaboratorMenu from "../collaboratorMenu";
import Footer from "../Footer";
import SearchForm from "../SearchForm";
import { isMobile, scrollToTop } from "../../utils/utils";
import MenuDropDown from "../MenuDropDown";
import { MENU_DESKTOP_NORMAL, MENU_MOBILE_NORMAL, MENU_MOBILE_USER, SUBMENU_TERM_OF_USE } from "../../utils/menu";
import { MINI_APP } from "../../utils/miniApp";
import { callEvent, EVENTS, listenEvent } from "../../utils/event";
import { DCStatic } from "../../models/DCStatic";
import { apiUpdateSetting } from "../../utils/api";

const eventChange = {
  onLanguage: () => { },
  onShipping: () => { },
  onCurrency: () => { },
  onChange: () => { }
};

export default class Header extends DComponent {
  constructor({
    parent,
    id,
    defaultLoading = true,
    hideCurrency = false,
    hideShipping = false,
    isNotSticky,
    title,
    isCheckout,
    isCollaboratorHeader,
    hideSearch = true,
    hideNavigation,
    hideBack,
    onBack,
    hideFooter,
    fixedMetaLang,
    onLoad = () => { },
    onEvent = eventChange,
    onSearch,
    onClear,
    autoComplete = true,
    onAutoComplete,
    isAutoOpen = false,
    darkMode,
    searchOptions = {},
    aboveSearchElement = "",
    customRightElement,
    hidePopupSetting = false,
  } = {}) {
    const isMiniApp = LocalStorage.isMiniApp();
    const darkModeClass = darkMode !== undefined ? darkMode : !isCollaboratorHeader;
    super(arguments[0], parent, id, {
      class: classNames("Header", {
        "is-checkout": isCheckout,
        "is-collaborator": isCollaboratorHeader,
        "is-compact": hideSearch && !isCheckout && !isCollaboratorHeader,
        "show-search": !hideSearch,
        "show-back": !hideBack && !isCollaboratorHeader,
        "show-title": title && hideSearch && !isCollaboratorHeader,
        "hide": LocalStorage.isOldApp(),
        "dark-mode": !!darkModeClass,
        "light-mode": !darkModeClass,
        "has-menu-mobile": customRightElement || isCollaboratorHeader || isCheckout,
      }),
      "aboveSearchElement": aboveSearchElement,
    }, true, defaultLoading);
    this.fixedMetaLang = fixedMetaLang;
    this.hideCurrency = hideCurrency;
    this.hideShipping = hideShipping;
    this.hideNavigation = hideNavigation;
    this.hideBack = hideBack;
    this.onBack = onBack;
    this.hideFooter = hideFooter;
    this.hideSearch = hideSearch;
    this.isNotSticky = isNotSticky;
    this.isCollaboratorHeader = isCollaboratorHeader;
    this.isCheckout = isCheckout;
    this.isMiniApp = isMiniApp;
    this.isMobile = isMobile();
    this.title = title;
    this.onLoad = onLoad;
    this.onEvent = onEvent;
    this.onSearch = onSearch;
    this.onClear = onClear;
    this.autoComplete = autoComplete;
    this.onAutoComplete = onAutoComplete;
    /** @type {MenuDropDown} */
    this.menuDropDown = undefined;
    /** @type {MenuDropDown} */
    this.menuDropDownMobile = undefined;
    this.footer = undefined;
    this.isAutoOpen = isAutoOpen;
    this.searchOptions = searchOptions;
    this.defaultLoading = defaultLoading;
    this.customRightElement = customRightElement;
    this.hidePopupSetting = hidePopupSetting;
    this.render();
  }

  loadStyle() {
    const style = require("!!css-loader!resolve-url-loader!sass-loader!./style.scss").toString();
    this.appendStyle(style, "Header");
  }

  loadHtml() {
    return require("html-loader!./index.html");
  }

  before() {
    setupLanguage(() => { this.setLoading(false); }, true, this.fixedMetaLang);
  }

  after() {
    if (this.customRightElement && typeof this.customRightElement === "object") this.addMemuMobile(this.customRightElement, true);

    DCStatic._modalPickerSetting = {
      hideCurrency: this.hideCurrency,
      hideShipping: this.hideShipping,
      fixedMetaLang: this.fixedMetaLang,
      onEvent: this.onEvent,
    }
    DCStatic.groupPickerSetting = {
      hideCurrency: this.hideCurrency,
      hideShipping: this.hideShipping,
      defaultLoading: this.defaultLoading,
      hide: this.isCheckout && isMobile(),
    }
    DCStatic.userBoxSetting = {
      showGuest: isMobile() ? false : this.isCheckout,
      defaultLoading: this.defaultLoading,
    }
    DCStatic.menuNavigationSetting = {
      isMiniApp: this.isMiniApp,
      hideNavigation: this.hideNavigation || this.isMiniApp,
      isAutoOpen: this.isAutoOpen,
      defaultLoading: this.defaultLoading,
    }

    this.showMenuMode(isMobile(), false);

    listenEvent(EVENTS.CHANGE_SETTING, () => {
      apiUpdateSetting();
    })
    DCStatic.setUpIpConfig(() => this.setUpLang(this.onLoad), this.hidePopupSetting);

    this.setUpTitleHeader();
    this.setUpEvent();

    if (!this.isNotSticky) {
      setTimeout(() => {
        Sticky($(".main-page:not(.collaborator) .Header"));
      }, 2000);
    }
    if (this.isCollaboratorHeader) {
      new CollaboratorMenu({ parent: this.element, isCollapse: window.outerWidth < 1024 || this.isMiniAp, addMemuMobile: (e, isCustom = true) => this.addMemuMobile(e, isCustom) });
    } else {
      if (!this.isMiniApp && !this.hideFooter) {
        this.footer = new Footer({ parent: ".section-footer", isCompact: this.isCheckout })
      }
      if (!this.hideSearch) {
        this.searchForm = new SearchForm({
          parent: $(".search-box .box-search", this.element),
          placeholderI18n: "header_placeholderSearch",
          noCheckValue: false,
          defaultValue: getParamUrl("k"),
          onSearch: this.onSearch,
          onClear: this.onClear,
          autoComplete: this.autoComplete,
          onAutoComplete: this.onAutoComplete,
          darkMode: true,
          ...this.searchOptions,
          defaultLoading: this.defaultLoading,
          onFocus: () => {
            $(".search-box", this.element).addClass("focus");
          },
          onBlur: () => {
            $(".search-box", this.element).removeClass("focus");
          }
        })
      }
    }
    if (LocalStorage.isLoggedIn() && !LocalStorage.getUserName() && !LocalStorage.isOldApp()) {
      if (!DCStatic.isMerchant) {
        DCStatic.authSocial.showAuthMoreInfo();
      }
    }
  }

  setUpLang(callback = () => { }) {
    setupLanguage(callback, false, this.fixedMetaLang);
    let defaultLanguage = detectLanguage(this.fixedMetaLang);
    callEvent(EVENTS.CHANGE_LANGUAGE, defaultLanguage);
    callEvent(EVENTS.CHANGE_COUNTRY, LocalStorage.getShipping());
    callEvent(EVENTS.CHANGE_CURRENCY, LocalStorage.getCurrency());
    callEvent(EVENTS.CHANGE_IP_COUNTRY, LocalStorage.getIpCountry());
  }

  setUpTitleHeader() {
    this.setTitleHeader();
    if (!this.hideBack) {
      $(".back", this.element).on("click", (e) => {
        if (this.onBack && typeof this.onBack === "function") {
          this.onBack();
        } else {
          if (this.isMiniApp && !LocalStorage.isOldApp()) {
            MINI_APP.back();
            return;
          }
          if (window.history.length) {
            window.history.go(-1);
          } else {
            window.location.href = ROOT_GLOBAL.HOME_PAGE;
          }
        }
      })
      window.onpopstate = () => {
        this.setTitleHeader();
      };
    }
  }

  setTitleHeader() {
    if (!isMobile() && !this.isCollaboratorHeader) return;
    let listMenu = [...SUBMENU_TERM_OF_USE, ...MENU_MOBILE_USER, ...MENU_MOBILE_NORMAL], path = window.location.pathname, hash = window.location.hash;
    let tempTitle = listMenu.find(item => item.regex ? item.regex.test(window.location.pathname) : ((path + hash).includes(item.href) || hash.includes(item.href)));
    let menuTitle = tempTitle?.label || "";
    this.setTitle(this.title || $.i18n(menuTitle), menuTitle)
  }

  setTitle(title, titleI18n = "") {
    $(".title", this.element).html(title);
    $(".title", this.element).attr("data-i18n", titleI18n);

    if (isMobile()) {
      if (title) {
        this.element.addClass("show-title");
        this.element.removeClass("show-logo");
      } else {
        this.element.removeClass("show-title");
        this.element.addClass("show-logo");
      }
    }
  }

  addMemuMobile(menuItems = [], isCustom = false) {
    if (window.isAddMenu) return;
    window.isAddMenu = true;
    if (!isCustom) {
      let element = document.createElement("img");
      element.src = require("../../assets/images/menu/navigation.svg");
      element.onmouseover = () => {
        if (!this.menuDropDownMobile) {
          this.menuDropDownMobile = new MenuDropDown({
            parent: element.parentElement,
            position: "left",
            width: "194px",
            menuItems: menuItems,
          })
        };
        this.menuDropDownMobile.show();
      }
      $(".border-box .menu-mobile", this.element).append(element);
    } else {
      $(".border-box .menu-mobile", this.element).append(menuItems);
    }
  }

  showMenuMode(isMobile, isResize = true) {
    $(".main-page").css("margin-bottom", !this.hideNavigation && isMobile && !this.isMiniApp && !(this.isCheckout && !$(".main-page").hasClass("empty")) ? "56px" : 0);
    $(".menu-collapse", this.element).toggleClass("burger", !isMobile);
    if (isMobile) {
      if (!this.isMiniApp && !(this.isCheckout && !$(".main-page").hasClass("empty"))) {
        DCStatic.menuNavigation.on();
      }
      if (isResize && this.footer && !this.isCompactFooter) this.footer.reloadElement();
    } else {
      $(".menu-collapse", this.element).addClass("burger");
      isResize && DCStatic.menuNavigation.off();
      DCStatic.groupPicker.changeParent($(".box-picker", this.element));
      DCStatic.userBox.changeParent($(".user-box", this.element));
      if (isResize && this.footer && !this.isCompactFooter) this.footer.reloadElement();
    }
  }

  setUpEvent() {
    this.setUpResize();
    this.setUpInstallExtension();
    this.setUpScroll();

    if (this.isMiniApp && !LocalStorage.isOldApp()) {
      $("body").on("click", ".Header .logo a, .Header .logo-mobile a", function (e) {
        e.preventDefault();
        MINI_APP.backHome();
      });
    }

    $(".box-picker", this.element).on("click", () => {
      if (isMobile() && this.isCheckout) {
        DCStatic.modalPicker.show();
      }
    });

    $(".menu-collapse.burger", this.element).on("mouseenter", () => {
      if (!this.menuDropDown && !isMobile()) {
        this.menuDropDown = new MenuDropDown({
          parent: $(".menu-collapse", this.element),
          position: "left",
          menuItems: MENU_DESKTOP_NORMAL,
          width: "220px"
        })
      }
    })
  }

  setUpResize() {
    $(window).on('resize', () => {
      if (isMobile() && !this.isMobile) {
        this.isMobile = true;
        this.showMenuMode(true);
        callEvent(EVENTS.RESIZE_SCREEN_MOBILE, { isMobile: true });
      }
      if (!isMobile() && this.isMobile) {
        this.isMobile = false;
        this.showMenuMode(false);
        callEvent(EVENTS.RESIZE_SCREEN_MOBILE, { isMobile: false });
      }
    });
  }

  setUpInstallExtension() {
    $(".btn-install-extension").on("click", (e) => {
      let shopping = $("body").attr("dce_cart"), isNewTab = $(e.currentTarget).attr("target") === "_blank";
      if (LocalStorage.hasExtension()) {
        if (shopping) {
          if (isNewTab) {
            window.open(ROOT_GLOBAL.CHECKOUT + "/" + shopping, "_blank")
          } else {
            window.location.href = ROOT_GLOBAL.CHECKOUT + "/" + shopping;
          }
        } else {
          if (isNewTab) {
            window.open(ROOT_GLOBAL.AVAILABLE_STORES, "_blank")
          } else {
            window.location.href = ROOT_GLOBAL.AVAILABLE_STORES;
          }
        }
      } else {
        if (isNewTab) {
          window.open(getExtensionLink(), "_blank")
        } else {
          window.location.href = getExtensionLink();
        }
      }
    });
  }

  setUpScroll() {
    window.onscroll = function () { scrollFunction() };

    function scrollFunction() {
      if (document.body.scrollTop > 100 || document.documentElement.scrollTop > 100) {
        $(".scroll-to-top").addClass("pop_class");
      } else {
        $(".scroll-to-top").removeClass("pop_class");
      }
    }

    $(".scroll-to-top").on("click", function (e) {
      e.preventDefault();
      scrollToTop(1000);
    })
  }
}